export default __webpack_public_path__ + "static/media/Temp3.db1f8f39.png";